import React from 'react'
import styles from '../AdminPanelPage.module.scss'

const CreatePrivatePointForm = ({ modalPayload = {}, setModalPayload = () => {}, closeModal = () => {}, createPrivatePoint, loadPrivatePoints = async () => {}, notifySuccess = () => {}, notifyError = () => {} }) => {
  return (
    <>
      <label>Название соц.объекта или МСУ</label>
      <input placeholder="Название" value={modalPayload.name || ''} onChange={(e) => setModalPayload(p => ({ ...p, name: e.target.value }))} />
      <label>Телефон</label>
      <input placeholder="Телефон" value={modalPayload.phone || ''} onChange={(e) => setModalPayload(p => ({ ...p, phone: e.target.value }))} />
      <label>Геолокация (широта,долгота)</label>
      <input placeholder="42.8746,74.5698" value={modalPayload.geo || ''} onChange={(e) => setModalPayload(p => ({ ...p, geo: e.target.value }))} />
      <div style={{ display: 'flex', gap: 8 }}>
        <button onClick={() => { closeModal() }} className={styles.btn_pin_close}>Отмена</button>
        <button onClick={async () => {
          try { await createPrivatePoint(modalPayload); await loadPrivatePoints(); closeModal(); notifySuccess('Частная точка создана') } catch (err) { console.error(err); notifyError(err, 'Не удалось создать частную точку') }
        }} className={styles.btn_pin}>Создать</button>
      </div>
    </>
  )
}

export default CreatePrivatePointForm
